import {request} from '../utils/request'
import {rbacApi} from '../config/urlConfig';
import {md5EncryptAddSalt} from "../utils/captcha";

/**
 * 查询所有用户
 */
export const findUserList = (data: any) =>
    request({
        url: `${rbacApi}/users/list`,
        method: 'post',
        data
    })


export const login = (payload: any) => {
    let data = {...payload};
    data.password = md5EncryptAddSalt(`${data.username}:`, data.password);
    return request({
        url: `${rbacApi}/users/login`,
        method: 'post',
        data
    })
}


/**
 * 微信绑定
 * @param data
 * @returns
 */
export const bindWechat = (data: any) =>
    request({
        url: `${rbacApi}/users/bindWechat`,
        method: 'post',
        data
    })

/** 微信授权回调，status: unbind | bind | frozen | error */
export const wxAuthCallback = (code: string, state = '') =>
    request({
        url: `/wechat-service-api/users/wxAuthCallback?${new URLSearchParams({code, state})}`,
        method: 'get',
    });


// 账号密码注册（完成创建租户和用户名）
export const registerSetting = (data: any) =>
    request({
        url: `${rbacApi}/users/registerSetting`,
        method: 'post',
        data
    })


/**
 * 根据账号查询用户信息是否存在
 */
export const isUserExistByAccount = (name: string) =>
    request({
        url: `${rbacApi}/users/isUserExistByAccount/${name}`,
        method: 'get'
    })


/**
 * 查询邀请码
 */
export const verifyInvitationCode = (data) =>
    request({
        url: `${rbacApi}/users/queryInvitationCodeRecord`,
        method: 'post',
        data
    })

/**
 * 更新邀请码记录
 * @param data
 */
export const updateInvitationCodeRecord = (data) =>
    request({
        url: `${rbacApi}/users/updateInvitationCodeRecord`,
        method: 'post',
        data
    })


export function register(payload: any) {
    let data = {...payload};
    data.password = md5EncryptAddSalt(`${data.username}:`, data.password);
    let req = request({
        url: `${rbacApi}/users/register`,
        method: 'post',
        data
    });
    // 是否开启了注册
    if (_get(window, "pointcode_ai.nocodb.api.switch")) {
        nocodbSignup(data.username); // 注册nocodb用户
    }
    // 人脸识别是否开启了注册
    if (_get(window, "pointcode_ai.nocodb.api.face")) {
        faceSignup(data.username); // 注册nocodb用户
    }
    return req;
}


/**
 * 判断字符串是否是邮箱
 * @param email
 */
export const isEmail = (email: string) => /^[\w.-]+@[a-z-A-Z\d]+\.[a-zA-Z-.]+$/.test(email)

/**
 * nocodb ai 用户注册请求
 * @param username
 */
export async function nocodbSignup(username: string) {
    let flg = isEmail(username); // 判断是否是邮箱
    if (flg) {
        username = `${username}@163.com`  // 不是邮箱默认给163邮箱
    }
    let data = JSON.stringify({
        "email": username,
        "password": (window as any).pointcode_ai.nocodb.userPassword,
        "token": "",
        "ignore_subscribe": true
    });
    await fetch((window as any).pointcode_ai.nocodb.api.signup, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
            'Xc-gui:': 'true'
        }
    });
}


/**
 * 人脸识别 ai 用户注册请求
 * @param username
 */
export async function faceSignup(username: string) {
    let flg = isEmail(username); // 判断是否是邮箱
    if (flg) {
        username = `${username}@163.com`  // 不是邮箱默认给163邮箱
    }
    let data = JSON.stringify({
        "email": username,
        "password": (window as any).pointcode_ai.face.userPassword,
        "firstName": username,
        "lastName": username
    });
    await fetch((window as any).pointcode_ai.face.api.signup, {
        method: 'POST',
        body: data,
        headers: {
            'Content-Type': 'application/json',
        }
    });
}